<template>
  <form-section
    :title="$t('CampaignForm_Locations_TriggerLimits_Title')"
    :description="$t('CampaignForm_Locations_TriggerLimits_Description')"
    :separator="true"
    :is-changed="model.diff && model.diff.includes('locationLimits')"
  >
    <!-- max number of triggers -->
    <form-item
      :label="$t('CampaignForm_Locations_TriggerLimits_MaxTriggers')"
      class="input-group"
    >
      <el-input-number
        class="limit-input-number"
        v-model="model.location_limit_per_user"
        :placeholder="$t('CampaignForm_Locations_TriggerLimits_Unlimited')"
        :controls="false"
        :min="0"
        :max="1000"
      />
      <el-select v-model="model.location_limit_per_user_period">
        <el-option
          value="day"
          :label="$t('CampaignForm_Locations_TriggerLimits_PerDay')"
        />
        <el-option
          value="campaign"
          :label="$t('CampaignForm_Locations_TriggerLimits_PerCampaign')"
        />
      </el-select>
    </form-item>

    <!-- max triggers per location -->
    <form-item
      :label="$t('CampaignForm_Locations_TriggerLimits_MaxPerLocation')"
      class="input-group"
    >
      <el-input-number
        class="limit-input-number"
        v-model="model.location_limit_per_location"
        :placeholder="$t('CampaignForm_Locations_TriggerLimits_Unlimited')"
        :controls="false"
        :min="0"
        :max="1000"
      />
      <el-select v-model="model.location_limit_per_location_period">
        <el-option
          value="day"
          :label="$t('CampaignForm_Locations_TriggerLimits_PerDay')"
        />
        <el-option
          value="campaign"
          :label="$t('CampaignForm_Locations_TriggerLimits_PerCampaign')"
        />
      </el-select>
    </form-item>

    <!-- number of prior enters before trigger -->
    <form-item
      :label="$t('CampaignForm_Locations_TriggerLimits_PriorEnters')"
      class="input-group"
    >
      <el-input-number
        class="limit-input-number"
        v-model="model.location_limit_nth_hit"
        :controls="false"
        :min="0"
        :max="1000"
      />
      <el-select v-model="model.location_limit_nth_hit_period">
        <el-option
          value="day"
          :label="$t('CampaignForm_Locations_TriggerLimits_PerDay')"
        />
        <el-option
          value="campaign"
          :label="$t('CampaignForm_Locations_TriggerLimits_PerCampaign')"
        />
      </el-select>
    </form-item>
    <journey-option-enter-once
      :model="model"
      v-if="model.type === campaignTypeEnum.TYPE_WORKFLOW"
    />
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import JourneyOptionEnterOnce from '@/modules/campaign-manage/components/JourneyOptionEnterOnce.vue'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'

export default {
  name: 'TriggerLimits',
  components: { FormItem, FormSection, JourneyOptionEnterOnce },
  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      campaignTypeEnum
    }
  },

  created() {
    if (this.model.location_limit_per_user === null) {
      this.model.location_limit_per_user = 1
    }
    if (this.model.location_limit_per_user_period === null) {
      this.model.location_limit_per_user_period = 'day'
    }
    if (this.model.location_limit_per_location === null) {
      this.model.location_limit_per_location = 1
    }
    if (this.model.location_limit_per_location_period === null) {
      this.model.location_limit_per_location_period = 'day'
    }
    if (this.model.location_limit_nth_hit === null) {
      this.model.location_limit_nth_hit = 0
    }
    if (this.model.location_limit_nth_hit_period === null) {
      this.model.location_limit_nth_hit_period = 'day'
    }
  }
}
</script>

<style scoped>
>>> .el-form-item__content {
  display: flex;
}

>>> .el-form-item__content > div:first-of-type {
  width: 80px;
  padding-right: 10px;
}

>>> .el-form-item__content > div:not(:first-of-type) {
  width: 165px;
  padding-right: 10px;
}

>>> .el-input-number.is-without-controls .el-input__inner {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/locations/TriggerLimits.vue